import { useCallback } from 'react';
import { Steps } from './Steps';
import {
  DetailsLoading,
  flowsQuery,
  IStep,
  IWork,
  LeftDrawerContentContainer,
  TOOLBAR_HEIGHT,
  useHeaderHeight,
  usePageLayoutStore,
} from '@diana/core';
import { useQuery } from '@tanstack/react-query';

export function Workflow({
  flowId,
  steps,
  isLoading,
  work,
}: {
  flowId?: string;
  steps?: IStep[];
  isLoading: boolean;
  work?: IWork;
}) {
  const setIsLeftDrawerOpen = usePageLayoutStore((store) => store.setIsLeftDrawerOpen);
  const onDrawerClose = useCallback(() => setIsLeftDrawerOpen(false), [setIsLeftDrawerOpen]);
  const headerHeight = useHeaderHeight() + TOOLBAR_HEIGHT + 11;

  const flowQueries = flowsQuery.getById({ id: flowId ?? '' });
  const { data: flow } = useQuery({
    queryKey: flowQueries.key,
    queryFn: flowQueries.fn,
    staleTime: Infinity,
    enabled: Boolean(flowId),
  });

  if (isLoading) {
    return <DetailsLoading />;
  }

  return (
    <LeftDrawerContentContainer
      sx={{ height: `calc(100vh - ${headerHeight}px)` }}
      id="workflow-sidebar"
    >
      {work ? <Steps steps={steps} work={work} closeDrawer={onDrawerClose} flow={flow!} /> : null}
    </LeftDrawerContentContainer>
  );
}
